// extracted by mini-css-extract-plugin
export default {"container":"style_container__460f5","loader":"style_loader__mWCpw","spin":"style_spin__ocqM1"};